module.exports = __webpack_public_path__ + "static/img/icon_case_3.65be887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_case_3.png
// module id = TAQ9
// module chunks = 0